import { Card } from "@volca/ui/components/ui/card";
import { Separator } from "@volca/ui/components/ui/separator";
import { cn } from "@volca/ui/lib/utils";
import { useGetBusinessStats } from "@/business/query";
import { useBusiness } from "@/core/business";
import { AdvocateAndReferralCounters } from "./advocate-and-referral-counters";
import { SignupLeaderboard } from "./signup-leaderboard";

interface ReferralStatsProps {
  className?: string;
}

export const ReferralStats = ({ className }: ReferralStatsProps) => {
  const { businessId } = useBusiness();
  const {
    data: businessStats,
    isLoading,
    isError,
  } = useGetBusinessStats(businessId);

  if (!businessId) return null; // preloaded at app level

  return (
    <Card
      data-cy="referral-stats"
      className={cn(
        "w-full gap-0 py-0 xl:min-h-0 xl:w-66 xl:shrink-0",
        className,
      )}
    >
      <AdvocateAndReferralCounters
        advocates={businessStats?.program_signup_count}
        referrals={businessStats?.referral_count}
        isLoading={isLoading}
        isError={isError}
      />
      <Separator />
      <SignupLeaderboard
        className="max-h-96 xl:max-h-none xl:min-h-0 xl:flex-1"
        businessId={businessId}
      />
    </Card>
  );
};
